import { useState } from "react";
import SearchCustomer from "./SearchCustomer";
import SearchStockList from "./SearchStockList";
import QuotationForm from "../QuotationForm";
import { arrayMap, arrayTextPrint } from "../../../utils/array.utils";
import StepTimeline from "./StepTimeline";
import { quotationFormatter } from "../../../utils/quotation.utils";
import { useNavigate } from "react-router-dom";

export default function QuotationStep({ title, editItem, existCustomer, redirectTo }) {
  const navigate = useNavigate();
  const editFormattedItem = quotationFormatter(editItem);

  // is exist customer? that means add from already have customer information through route state
  const isExistCustomer = !!existCustomer?.profile?.id;

  const [step, setStep] = useState({
    customer: editFormattedItem?.customer
      ? editFormattedItem?.customer
      : isExistCustomer
        ? existCustomer
        : null,
    car: editFormattedItem?.car ? editFormattedItem?.car : null,
    currentStep: editFormattedItem?.id ? 3 : isExistCustomer ? 2 : 1,
    customerSearch: editFormattedItem?.cid ?? "",
    carSearch: editFormattedItem?.car?.chassis ?? "",
    isMultiQuot:
      typeof editFormattedItem?.is_multi === "boolean" ? editFormattedItem?.is_multi : false,
    multiCars: editFormattedItem?.car?.length ? editFormattedItem?.car : []
  });

  const onBack = () => {
    if (isExistCustomer && existCustomer?.profile?.customer_id) {
      if (step?.currentStep === 3) {
        setStep((prev) => ({ ...prev, currentStep: prev.currentStep - 1 }));
      } else {
        navigate(redirectTo);
      }
    } else {
      setStep((prev) => ({ ...prev, currentStep: prev.currentStep - 1 }));
    }
  };

  const customer = step?.customer ?? null;
  const car = step?.car ?? null;
  const descriptions = car?.features?.length ? arrayTextPrint(car?.features) : "";

  let defaultValues = {
    customer: {
      name: customer?.profile?.name ?? "",
      designation: customer?.profile?.designation ?? "",
      address: customer?.address ?? "",
      customer_id: customer?.profile?.id ?? "",
      account_name: customer?.profile?.account_name ?? ""
    },
    qoutDate: editFormattedItem?.qoutDate ? editFormattedItem.qoutDate : new Date(),
    validUntil: editFormattedItem?.validUntil ? editFormattedItem.validUntil : "",
    id: editFormattedItem?.id ? editFormattedItem.id : "",
    multiCars: step.multiCars,
    isMultiQuot: step.isMultiQuot,
    amount: editFormattedItem?.amount ?? ""
  };

  if (step.isMultiQuot) {
    defaultValues.car =
      arrayMap(step?.multiCars, (item, index) => {
        return {
          stock_list_id: item?.id ?? "",
          sku: item?.sku ?? "",
          name: item?.name ?? "",
          chassis: item?.fullChassis ?? "",
          engine: item?.engine ?? "",
          year: item?.year ?? "",
          color: item?.color ?? "",
          cc: item?.cc ?? "",
          fuel: item?.fuel ?? "",
          descriptions: item?.features?.length ? arrayTextPrint(item?.features) : "",
          price: item?.discount_price ?? item?.price ?? "",
          registration_cost: item?.registration_cost ?? "",
          total: item?.total ?? "",
          inwords: item?.inwords ?? ""
        };
      }) || [];
  } else {
    defaultValues.car = {
      stock_list_id: car?.id ?? "",
      sku: car?.sku ?? "",
      name: car?.name ?? "",
      chassis: car?.fullChassis ?? "",
      engine: car?.engine ?? "",
      year: car?.year ?? "",
      color: car?.color ?? "",
      cc: car?.cc ?? "",
      fuel: car?.fuel ?? "",
      descriptions,
      price: car?.discount_price ?? car?.price ?? "",
      registration_cost: car?.registration_cost ?? "",
      total: car?.total ?? "",
      inwords: car?.inwords ?? ""
    };
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 mx-auto">
          <StepTimeline step={step} />
          {step.currentStep === 1 && <SearchCustomer step={step} setStep={setStep} />}
          {step.currentStep === 2 && (
            <SearchStockList step={step} setStep={setStep} onBack={onBack} />
          )}
        </div>
        {step.currentStep === 3 && (
          <QuotationForm
            existCustomer={existCustomer}
            title={title}
            defaultValues={defaultValues}
            onBack={onBack}
          />
        )}
      </div>
    </>
  );
}
